import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsConnectionsMessages = defineMessages(
  "settings-connections",
  en,
);
